<template>
  <div class="contents">
    <div class="container-fluid">
      <InvoicePageHeader title="Modul Invoice">
        <template #actions>
          <router-link to="/invoice/create" class="btn px-15 btn-primary text-white">
            <i class="fas fa-plus fs-16"></i>
            Buat Invoice
          </router-link>
        </template>
      </InvoicePageHeader>

      <div class="inv-stat-grid">
        <div class="inv-stat-card">
          <div class="inv-stat-card__label">Total invoice</div>
          <div class="inv-stat-card__value">{{ stats.total }}</div>
        </div>
        <div class="inv-stat-card">
          <div class="inv-stat-card__label">Draft</div>
          <div class="inv-stat-card__value">{{ stats.draft }}</div>
        </div>
        <div class="inv-stat-card">
          <div class="inv-stat-card__label">Belum lunas</div>
          <div class="inv-stat-card__value inv-stat-card__value--accent">{{ stats.unpaid }}</div>
        </div>
        <div class="inv-stat-card">
          <div class="inv-stat-card__label">Nilai terkirim + draft</div>
          <div class="inv-stat-card__value">{{ formatRp(stats.pipeline) }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
            <div class="inv-toolbar">
              <div class="inv-search">
                <i class="fas fa-search"></i>
                <input v-model="search" type="text" class="form-control" placeholder="Cari nomor atau customer…">
              </div>
              <div class="inv-filter">
                <select v-model="filterStatus" class="form-control" @change="load">
                  <option value="">Semua status</option>
                  <option value="draft">Draft</option>
                  <option value="sent">Terkirim</option>
                  <option value="paid">Lunas</option>
                  <option value="cancelled">Batal</option>
                </select>
              </div>
            </div>

            <div v-if="loading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="text-muted mt-2 mb-0">Memuat invoice…</p>
            </div>

            <div v-else-if="filteredInvoices.length === 0" class="inv-empty">
              <div class="inv-empty__icon"><i class="fas fa-file-invoice"></i></div>
              <h5>Belum ada invoice</h5>
              <p>Buat invoice pertama untuk customer Anda, kirim PDF via WhatsApp atau email.</p>
              <router-link to="/invoice/create" class="btn btn-primary px-4">Buat Invoice</router-link>
            </div>

            <div v-else class="inv-table-wrap">
              <table class="table inv-table mb-0">
                <thead>
                  <tr>
                    <th>Nomor</th>
                    <th>Customer</th>
                    <th>Total</th>
                    <th>Status</th>
                    <th class="text-right">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="inv in filteredInvoices" :key="inv.id">
                    <td>
                      <div class="inv-table__number">{{ inv.invoice_number }}</div>
                      <div class="inv-table__muted" v-if="inv.created_at">{{ formatDate(inv.created_at) }}</div>
                    </td>
                    <td>
                      <div>{{ inv.customer_name || '—' }}</div>
                      <div class="inv-table__muted" v-if="inv.customer_phone">{{ inv.customer_phone }}</div>
                    </td>
                    <td><strong>{{ formatRp(inv.total) }}</strong></td>
                    <td><span :class="statusMeta(inv.status).badge">{{ statusMeta(inv.status).label }}</span></td>
                    <td class="text-right">
                      <router-link :to="'/invoice/' + inv.id" class="btn btn-sm btn-outline-primary">
                        Detail
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import InvoicePageHeader from '@/components/invoice/InvoicePageHeader.vue';
import { formatRp, statusMeta } from '@/utils/invoiceUi';
import '@/assets/invoice-module.css';

export default {
  components: { InvoicePageHeader },
  data() {
    return { invoices: [], filterStatus: '', search: '', loading: true };
  },
  computed: {
    filteredInvoices() {
      const q = (this.search || '').trim().toLowerCase();
      if (!q) return this.invoices;
      return this.invoices.filter(inv => {
        const num = (inv.invoice_number || '').toLowerCase();
        const name = (inv.customer_name || '').toLowerCase();
        return num.includes(q) || name.includes(q);
      });
    },
    stats() {
      const list = this.invoices;
      let pipeline = 0;
      list.forEach(inv => {
        if (inv.status === 'draft' || inv.status === 'sent') {
          pipeline += Number(inv.total || 0);
        }
      });
      return {
        total: list.length,
        draft: list.filter(i => i.status === 'draft').length,
        unpaid: list.filter(i => i.status === 'sent' || i.status === 'draft').length,
        pipeline
      };
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    formatRp,
    statusMeta,
    formatDate(ts) {
      if (!ts) return '';
      const d = new Date(typeof ts === 'number' && ts > 1e12 ? ts : ts * 1000);
      if (Number.isNaN(d.getTime())) return '';
      return d.toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' });
    },
    load() {
      this.loading = true;
      axios.get('invoice/invoices', { params: { status: this.filterStatus } })
        .then(r => {
          this.invoices = r.data.data.invoices || [];
        })
        .catch(e => this.$toast.error(e.response?.data?.message || 'Gagal memuat invoice'))
        .finally(() => { this.loading = false; });
    }
  }
};
</script>
